<template>
    <div class="teams">
      <div class="badge">
        <img :src="filterImage(item.badge,50,50)">
      </div>
      <div class="detail">
        <div class="name">{{ item.name }}</div>
        <div class="location">{{ item.location }}</div>
        <div class="bot">
          <div class="but"></div>
          <div style="font-size: 12px;" @click="goTeamList(item.id, item.playerCount)">
            {{ $t('match.homeTabs.text_6') }}
            <span v-if="item.playerCount !== 0">{{ item.playerCount }}</span>
            <span style="color: #9B9B9B;" v-else>{{ $t('match.homeTabs.text_7') }}</span></div>
        </div>
      </div>
    </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  name: 'Teams',
  props: {
    item: {
      typeof: Object,
      default: {}
    },
    matchId: String,
    showPlayerList: {
      typeof: Number,
      default: 0
    }
  },
  methods: {
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    goTeamList(id,num) {
      if (this.showPlayerList === -1) {
        Toast('组委会暂未开放名单查看功能')
        return
      }
      if (num == 0) return Toast('参赛名单未公布')
      this.$router.push({ name: 'AttendPlayer', query: { matchId: this.matchId, teamId: id } })
    }
  }
}
</script>

<style scoped lang="scss">
.teams{
  display: flex;
  background-color: #fff;
  padding: 15px;
  .badge{
    img{
      width: 50px;
      height: 50px;
    }
  }
  .detail{
    flex: 1;
    margin-left: 15px;
    .name{
      font-size: 14px;
    }
    .location{
      color: #ababab;
      font-size: 12px;
      padding: 8px 0;
    }
    .bot{
      display: flex;
      justify-content: space-between;
      color: #ababab;
      padding-bottom: 15px;
      border-bottom: 1px solid #F2F2F2;
      .but{
        // border: 1px solid #E2E2E2;
        border-radius: 3px;
        color: #EC4E4E;
        font-size: 14px;
        padding: 2px 14px;
      }
      span{
        color: #EC4E4E;
      }
    }
  }
}
</style>
